export default {
  title: '! Zamówienia wstrzymane do {{time}}',
  button: 'Wznów',
  labels: {
    rest_of_day: 'reszta dnia',
  },
};
